import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const Rendercscbundle = () => {

const resturl=sessionStorage.getItem("RESTURL");
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;
//let arrapptypeIndex0=null;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const yesnooptions = <>
		<option value="0" >No</option>
		<option value="1" >Yes</option>
		</>;
const genderoptions = <>
		<option value="F" >Female</option>
		<option value="M" >Male</option>
		</>;

const [modal, setModal] = useState({open:false});
//const [renders, setRenders] = useState({count:0});
const navWpform = React.useRef();
const [tblbdlapp, settblBdlapp] = useState([]);
const [tblcardprintdate, setTblcardprintdate] = useState([]);

const [tblbdlname, setTblbdlname] = useState([]);

const [arrbdlname, setArrbdlname] = useState([]);
const [arrapptype, setArrapptype] = useState([]);
const [arrformfields, setArrformfields] = useState([]);
const [arrfieldrows, setArrfieldrows] = useState([]);
const [currfieldrows, setCurrfieldrows] = useState([]);


const [apptypeoptions, setApptypeoptions] = useState([]);

const [defapptype, setDefapptype] = useState({
	id: ''
});



const [currbdl, setCurrbdl] = useState({
	id: ''
	, name: ''
	, code: ''
	, frm: ''
});

const [needrerenderrows, setNeedrerenderrows] = useState({done:false});
const [cscbundle, setcscbundle] = useState({});
const [combolocation, setCombolocation] = useState([]);

const emptyBdlapp={
BDL_APP_ID: "0"
, BUNDLE_ID: ""
, APP_TYPE_ID: ""
, APPLICANT: ""
, MPE_FNAME: ""
, MPE_LNAME: ""
, MPE_MNAME: ""
, SENT_UIA: ""
, COMMENTS: ""
, MPR_NAME: ""
, MPE_DOB: ""
, MPE_PSP_NBR: ""
, MPE_PSP_CTY: ""
, MPE_GDR: ""
};

const [bdlapp, setBdlapp] = useState(emptyBdlapp);
const [dowait, setDowait] = useState({on:false});

const [searchcrit, setSearchcrit] = useState({
	BUNDLE_ID: ""
	, APP_TYPE_ID: ""
	, WORD: ""
	, MPE_PSP_CTY: ""
	, MPE_GDR: ""
	});




const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

//start with setupArrfieldrows(); instead of getarrbdlname();
getarrbdlname();


 },[]);


useEffect(() => {

if (arrbdlname.length>0){
	writetblbdlname();

	if (tblbdlapp.length==0)
		gettblbdlapp();
	}//end if

	
 },[JSON.stringify(arrbdlname)]);
 
 
useEffect(() => {
if (tblbdlapp.length>0)
	focusformElement();
	
 },[JSON.stringify(tblbdlapp)]);


useEffect(() => {

//console.log("currbdl.code: "+currbdl.code);
//console.log("arrbdlname.length: "+arrbdlname.length);

if (currbdl.code!="" && arrbdlname)
	if (arrbdlname.length>0)
		for (var i=0; i<arrbdlname.length; i++){
			const tempbdlname=arrbdlname[i];
			//console.log("tempbdlname: "+JSON.stringify(tempbdlname));
			if (tempbdlname.BDL_CODE==currbdl.code)
				setCurrbdl((prev)=>{
					//console.log("arrbdlname[i]: "+JSON.stringify(arrbdlname[i]));
					return {
						...prev
						, id: tempbdlname.BUNDLE_ID
						, frm: tempbdlname.FORM_NUM
						, name: tempbdlname.BUNDLE
						};
					});
			}//end for


let tempopts=[];
if (currbdl.code!="" && arrapptype)
	if (arrapptype.length>0)
		for (var i=0; i<arrapptype.length; i++){
			const tempapptype=arrapptype[i];
			const key="app_type_"+i;
			//console.log("tempapptype: "+JSON.stringify(tempapptype));
			if (tempapptype.BDL_CODE==currbdl.code){
				tempopts.push(<option value={tempapptype.APP_TYPE_ID} key={key} >{tempapptype.APP_TYPE}</option>);
				setDefapptype({id:i});
				//console.log("set arrapptypeIndex0: "+arrapptypeIndex0);
				}
				
			}//end for	

setApptypeoptions(tempopts);

 },[currbdl.code]);

useEffect(() => {

//console.log("apptypeoptions: "+JSON.stringify(apptypeoptions));

if (apptypeoptions.length>0){
	if (arrfieldrows.length>0)
		setupCurrfieldrows();
	else
		setupArrfieldrows();
	}//end if
	
	
 },[JSON.stringify(apptypeoptions)]);


useEffect(() => {

//console.log("arrfieldrows.length: "+arrfieldrows.length);
//when arrfieldrows changes then reset currfieldrows
if (arrfieldrows.length>0)
	setupCurrfieldrows();
	
 },[arrfieldrows.length]);


function rerenderRows(){
//this will trigger useEffect on arrfieldrows.length
setArrfieldrows([]);
}//end func


useEffect(() => {
if (needrerenderrows.done==false)
	rerenderRows();
 },[bdlapp]);


useEffect(() => {
//console.log("arrfieldrows.length: "+arrfieldrows.length);
if (arrfieldrows.length==0 && 1*currbdl.id>0){
	setNeedrerenderrows({done:true});
	setupArrfieldrows();
	}
	
	
 },[arrfieldrows.length]); 


useEffect(() => {
//console.log("arrfieldrows.length: "+arrfieldrows.length);
if (1*currbdl.id>0)
	setBdlapp((prev)=>{
		return {...prev, BUNDLE_ID:currbdl.id}
	});
	
 },[currbdl.id]);


useEffect(() => {

if (currfieldrows.length>0){
	setNeedrerenderrows({done:false});
	focusformElement();
	}//end if
	
 },[currfieldrows.length]);


/*
useEffect(() => {
//if theres only one then select it
console.log("apptypeoptions.length: "+apptypeoptions.length);
if (arrapptypeIndex0!=null && apptypeoptions.length==1 && (bdlapp.APP_TYPE_ID=="" || bdlapp.APP_TYPE_ID==undefined) )
	setBdlapp((prev)=>{
		console.log("bdlapp.APP_TYPE_ID: "+bdlapp.APP_TYPE_ID);
		const curr_APP_TYPE_ID = arrapptype[arrapptypeIndex0].APP_TYPE_ID;
		console.log("curr_APP_TYPE_ID: "+curr_APP_TYPE_ID);
		return {...prev, APP_TYPE_ID: curr_APP_TYPE_ID}
		});
	//arrapptype();
 },[bdlapp.APP_TYPE_ID, currbdl.id]);
*/


function handleChange(e){

const {name, value}=e.target;
//console.log("handleChange.name: "+ name+" <-- "+value)	;
setBdlapp((prev)=>{
	return {...prev, [name]:value}
	});

if (document.getElementById("btnupdate"))	
	document.getElementById("btnupdate").style.visibility="visible";
	
}//end func


function focusformElement(){
if (document.getElementsByName('MPE_FNAME')[0])
	document.getElementsByName('MPE_FNAME')[0].focus();
else if (document.getElementsByName('APPLICANT')[0])
	document.getElementsByName('APPLICANT')[0].focus();	


console.log("defapptype.id: "+defapptype.id);
console.log("apptypeoptions.length: "+apptypeoptions.length);
if (apptypeoptions.length==1 && defapptype.id>0)
	setBdlapp((prev)=>{
		const currAPP_TYPE_ID = arrapptype[defapptype.id].APP_TYPE_ID;
		console.log("currAPP_TYPE_ID: "+currAPP_TYPE_ID);
		return {...prev, APP_TYPE_ID:currAPP_TYPE_ID}
		});	

}//end func


async function getarrbdlname(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarlogbook/getarrbdlname',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetarrbdlname(res) )
      .catch(err => console.log(err));

}//end func


function aftergetarrbdlname(res){

if (res.length==undefined)
	return;

let temparrnames=[];
const names=res[0].names;
	names.map((col, index) => {
		temparrnames.push({
			BUNDLE_ID: col['BUNDLE_ID']
			,BDL_CODE: col['BDL_CODE']
			,BUNDLE: col['BUNDLE']
			,FORM_NUM: col['FORM_NUM']
			});
		});

//console.log("temparrbdl: "+JSON.stringify(temparrnames))	;
		
setArrbdlname(temparrnames);

let temparrtypes=[];
const types=res[0].types;
	types.map((col, index) => {
		temparrtypes.push({
			APP_TYPE_ID: col['APP_TYPE_ID']
			,BDL_CODE: col['BDL_CODE']
			,APP_TYPE: col['APP_TYPE']
			});
		});

//console.log("temparrtypes: "+JSON.stringify(temparrtypes))	;

setArrapptype(temparrtypes);


let tempformfields=[];
const formfields=res[0].formfields;
	formfields.map((col, index) => {
		tempformfields.push({
			FORM_NUM: col['FORM_NUM']
			,NDX: col['NDX']
			,FLD: col['FLD']
			,FLG: col['FLG']
			});
		});


setArrformfields(tempformfields);


}//end func

function writetblbdlname(){
	
	let temphtm1=[];
	let temphtm2=[];
	arrbdlname.map((col, index) => {
		
		//const key="bdl_tr_"+index;
		const rd_id="bdl_rdid_"+index;
		const td_id="bdl_tdid_"+index;
		const code=col['BDL_CODE'];
		const radio1=<>
					<input name="rd_bundle_type" type='radio' id={rd_id} onClick={(e)=>{setCurrbdl({code:code});}} />
					<label htmlFor={rd_id} className="hand" >{col['BUNDLE']}</label>
					</>;
		
		if (index<6)
			temphtm1.push(
				<td align="center" key={td_id} >{radio1}</td>
			);
		else
			temphtm2.push(
				<td align="center" key={td_id} >{radio1}</td>
			);
		});	//end map
		
let temphtm=[];
temphtm.push(<tr key="bdl_tr_001" >,{temphtm1},</tr>,<tr key="bdl_tr_002" >,{temphtm2},</tr>);
//console.log("temphtm: "+JSON.stringify(temphtm)); qr 
setTblbdlname(temphtm);
}//end func


async function submitform1(e){

if (e)
	e.preventDefault();

let temp=bdlapp;
temp.USERNAME=sessionStorage.getItem("USERNAME");
temp.BUNDLE_ID=currbdl.id;

console.log("submitform1 temp: "+JSON.stringify(temp));
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( temp )
  };		

await  fetch(resturl+'rarlogbook/updatebdlapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersubmitform1(res) )
      .catch(err => console.log(err));

}//end func


function aftersubmitform1(res){
	//setCurrfieldrows([]);
	//emptyBdlapp
	setBdlapp((prev)=>{
		prev=emptyBdlapp;
		return {...prev}
		});
	showsnackbar("done!");
	
	gettblbdlapp();
	
}//end func

async function gettblbdlapp(){

let temp=searchcrit;
temp.username=sessionStorage.getItem("USERNAME");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( temp )
  };		
settblBdlapp([]);
await  fetch(resturl+'rarlogbook/gettblbdlapp',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblbdlapp(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblbdlapp(res){

if (res.length==undefined)
	return;
	
console.log('aftergettblbdlapp, res.length: '+res.length);
let htmrows=[];

res.map((col, index) => {
	const USERNAME=col['USERNAME'];
	const trkey='tr_'+index;
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{index+1}</td>
	<td align='right' >{col['BDL_APP_ID']}</td>
	<td align='left' >{col['BDL_CODE']}</td>
	<td align='left' >{col['APP_TYPE']}</td>
	<td align='center' >{col['STR_SENT_UIA']}</td>
	<td align='left' >{col['APPLICANT']}</td>
	<td align='left' >{col['MPE_GDR']}</td>
	<td align='center' >{col['TC_MPE_DOB']}</td>
	<td align='left' >{col['MPE_PSP_NBR']}</td>
	<td align='left' >{col['MPE_PSP_CTY']}</td>
	<td align='left' >{col['MPR_NAME']}</td>
	<td align='left' >{col['STR_COMMENTS']}</td>

	</tr>;
	htmrows.push(htmrow);


});
/*
		<th>Id #</th>
		<th>Bundle</th>
		<th>Type</th>
		<th>Advance</th>
		<th>Gender</th>
		<th>Passport Country<br/>Of Issue</th>
		<th>Applicant</th>
		<th>DOB</th>
		<th>Passport #</th>
		<th>Employer</th>
		<th>Comment</th>

*/
settblBdlapp(htmrows);
}//end func



async function getwpformoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		

 await fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwpformoptions(res){

let templocation=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='location' && !strOption.toUpperCase().includes("UNKNOWN"))
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
	
	});//end map
setCombolocation(templocation);
//document.getElementsByName('COMPANY')[0].focus();	

}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func



function aftergetbdlapp(res){


/*
let datas=bdlapp;

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	

setBdlapp((prev)=>{
	return {...prev, datas}
});
*/


}//end func



function setupArrfieldrows(){
let arrtemp=[];
console.log("setupArrfieldrows: "+arrfieldrows.length);

/*
2025-06-28
this method must be called in useEffect of app 
otherwise it will not display the updated values of bdlapp.APPLICANT, bdlapp.MPE_FNAME, etc
rerenderRows() is called in useEffect to fix this

input elements are not updating after onChange={(e)=>{handleChange(e); }}
the input elements are not seeing the onChange??
the input elements must be written after the onChange??h ter

*/
arrtemp.push(<tr  key="tr_bdlapp_01"  ><td align="left" ><input name="APPLICANT" value={bdlapp.APPLICANT} type="text" required placeholder="Applicant's name" onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /></td></tr>);
arrtemp.push(<tr  key="tr_bdlapp_02"  ><td align="left" ><input name="MPE_FNAME" value={bdlapp.MPE_FNAME} type="text" required placeholder="Employee's first name" onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /></td></tr>);
arrtemp.push(<tr  key="tr_bdlapp_03"  ><td align="left" ><input name="MPE_LNAME" value={bdlapp.MPE_LNAME} type="text" required placeholder="Employee's last name"onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /></td></tr>);
arrtemp.push(<tr  key="tr_bdlapp_04"  ><td align="left" ><input name="MPE_MNAME" value={bdlapp.MPE_MNAME} type="text"  placeholder="Employee's middle name" onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /></td></tr>);
	
arrtemp.push(
	<tr  key="tr_bdlapp_05"  >
	<td align="left" className="tooltip" >
			<select name="SENT_UIA" value={bdlapp.SENT_UIA} required onChange={(e)=>{handleChange(e); }}  >
			<option value='' > - sent up - </option>
			{yesnooptions}
			</select>
			<span className="tooltiptext">sent up in advance</span>
	</td>
	</tr>
	);

arrtemp.push(<tr  key="tr_bdlapp_11"  ><td align="left" ><textarea name="COMMENTS" value={bdlapp.COMMENTS} placeholder="comments" onChange={(e)=>{handleChange(e); }}  rows="5" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  ></textarea></td></tr>);


arrtemp.push(<tr  key="tr_bdlapp_06"  ><td align="left" ><input name="MPR_NAME" value={bdlapp.MPR_NAME} type="text" placeholder="Employer's name" required onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /></td></tr>);
arrtemp.push(<tr  key="tr_bdlapp_07"  ><td align="left" className="tooltip" ><input name="MPE_DOB" type="date" value={bdlapp.MPE_DOB} required onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /><span className="tooltiptext">Date of Birth</span></td></tr>);
arrtemp.push(<tr  key="tr_bdlapp_08"  ><td align="left" ><input name="MPE_PSP_NBR" value={bdlapp.MPE_PSP_NBR} type="text" placeholder="applicant's passport #" required onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /></td></tr>);
//arrtemp.push(<tr  key="tr_bdlapp_00"  ><td align="left" ><select name="MPE_PSP_CTY" value={bdlapp.MPE_PSP_CTY} required onChange={(e)=>{handleChange(e); }} ></select></td></tr>);
arrtemp.push(<tr  key="tr_bdlapp_09"  ><td align="left" ><input name="MPE_PSP_CTY" value={bdlapp.MPE_PSP_CTY} type="text" placeholder="applicant's passport Country" required onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  /></td></tr>);
arrtemp.push(<tr  key="tr_bdlapp_10"  ><td align="left" ><select name="MPE_GDR" value={bdlapp.MPE_GDR} required onChange={(e)=>{handleChange(e); }} ><option value='' > - gender - </option>{genderoptions}</select></td></tr>);

//console.log("arrfieldrows: arrtemp.length: "+arrtemp.length);

setArrfieldrows(arrtemp);	
}//end func


function setupCurrfieldrows(){
let fieldrows=[];	

if (!arrformfields.length)
	return;
if (arrformfields.length==0)
	return;


console.log("arrformfields.length: "+ arrformfields.length );

fieldrows.push(	<tr key="tr_bdlapp_000" >
	<td align="left" >
		<select name="APP_TYPE_ID" value={bdlapp.APP_TYPE_ID} required onChange={(e)=>{handleChange(e); }} >
		<option value='' key="app_type_000" > - type - </option>
		{apptypeoptions}
		</select>
	</td>
	</tr>);

//console.log("arrformfields: "+JSON.stringify(arrformfields));

for (var i=0; i<arrformfields.length; i++){
	const formfield=arrformfields[i];
	
	if (formfield.FORM_NUM==currbdl.frm && formfield.NDX>0){
		//console.log("formfield: "+ JSON.stringify(formfield))	;
		fieldrows.push(arrfieldrows[formfield.NDX-1]);
		}
		
	}//end for

console.log("fieldrows.length: "+ fieldrows.length)	;
setCurrfieldrows(fieldrows);
	
}//end func












	
  return (
    <>
	
<div align='center' style={{marginTop:"10px", marginBottom:"10px"}}>
	{/*
	search criteria:&nbsp;<input name='searchcrit' defaultValue={searchcrit.text} onChange={(e)=>{searchcritChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='username or email address' />
	*/}

</div>
	
	<table border="1" >
	<tbody>
		{tblbdlname}
	</tbody>
	</table>
	
	
	<table align='center' border="0" style={{width:"96%", marginTop:"12px", marginBottom:"18px"}} >
	<tbody>
	<tr valign="top" >
		<td align='center' >
			<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
			<table align="center" >
			<tbody>
			{currfieldrows}
			<tr>
			<td>
			<button  className="button" id="btnupdate" style={{visibility:"hidden"}} >save changes</button>
{/*
<br/><input name="MPR_NAME" value={bdlapp.MPR_NAME} type="text" placeholder="Employer's name" required onChange={(e)=>{handleChange(e); }}  size="12" autoComplete="off" onFocus={(e)=>{e.target.select(); }}  />
			<br/>{renders.count}
*/}			
			
			</td>
			</tr>
			{
				currbdl.id &&
				<tr>
				<td>
				<br/>bundle Id: {currbdl.id}
				<br/>Default Type Id: {defapptype.id}
				</td>
				</tr>
			}

			</tbody>
			</table>
			</form>
			
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='center' >
		<table align='center' className='customers' style={{width:"100%"}} >
		<thead>
		<tr>
			<th>#</th>
			<th>Id #</th>
			<th>Bundle</th>
			<th>Type</th>
			<th>Sent Up</th>
			<th>Applicant</th>
			<th>Gender</th>
			<th>DOB</th>
			<th>Passport #</th>
			<th>Passport<br/>Country</th>
			<th>Employer</th>
			<th>Comments</th>
			
		</tr>
		</thead>
		<tbody>
			{tblbdlapp}
		</tbody>
		</table>
		</td>
	</tr>
	</tbody>
	</table>


	
	
	
	

<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default Rendercscbundle;